// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-shell {
  display: flex;
  min-height: 100vh;
  background: var(--bg);
}

.app-side {
  position: sticky;
  top: 0;
  display: none;
  flex-direction: column;
  width: 254px;
  height: 100vh;
  padding: 22px 16px;
  background: var(--surface);
  border-right: 1px solid var(--border);
}

.app-side-brand {
  display: block;
  padding: 0 8px 22px;
}

.app-side-brand img {
  height: 44px;
  width: auto;
}

.app-side-nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.app-side-link {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 11px 12px;
  border-radius: var(--radius-sm);
  font-family: var(--font-display);
  font-size: 0.92rem;
  font-weight: 600;
  color: var(--muted);
  text-decoration: none;
  transition: background 0.2s, color 0.2s;
}

.app-side-link:hover {
  background: var(--brand-50);
  color: var(--brand);
}

.app-side-link.active {
  background: var(--brand);
  color: #fff;
  box-shadow: var(--shadow-brand);
}

.app-side-foot {
  margin-top: auto;
  padding-top: 18px;
  border-top: 1px solid var(--border);
}

.app-user {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 4px 14px;
}

.app-user-avatar,
.app-user-initials {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
}

.app-user-initials {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--grad-brand);
  color: #fff;
  font-family: var(--font-display);
  font-size: 0.82rem;
  font-weight: 700;
}

.app-user-info {
  min-width: 0;
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.app-user-info strong {
  font-size: 0.88rem;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.app-user-info span {
  font-size: 0.76rem;
  color: var(--muted2);
}

.app-signout {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: #fff;
  color: var(--muted);
  font-family: var(--font-display);
  font-size: 0.86rem;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.app-signout:hover:not(:disabled) {
  border-color: var(--danger-100);
  color: var(--danger);
}

.app-signout:disabled {
  opacity: 0.6;
  cursor: default;
}

.app-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.app-topbar {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 18px;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--border);
}

.app-topbar-brand img {
  height: 38px;
  width: auto;
  display: block;
}

.app-topbar-user {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  background: var(--grad-brand);
  color: #fff;
  font-family: var(--font-display);
  font-size: 0.78rem;
  font-weight: 700;
  text-decoration: none;
}

.app-topbar-user img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.app-content {
  flex: 1 1;
  padding: 20px 18px calc(76px + env(safe-area-inset-bottom));
  max-width: 1080px;
  width: 100%;
  margin: 0 auto;
}

.app-tabbar {
  position: fixed;
  z-index: 200;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(12px);
  border-top: 1px solid var(--border);
  padding-bottom: env(safe-area-inset-bottom);
}

.app-tab {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 9px 2px 8px;
  color: var(--muted2);
  text-decoration: none;
  transition: color 0.2s;
}

.app-tab span {
  font-family: var(--font-display);
  font-size: 0.66rem;
  font-weight: 600;
  letter-spacing: -0.1px;
}

.app-tab.active {
  color: var(--brand);
}

@media (min-width: 900px) {
  .app-side {
    display: flex;
  }

  .app-topbar,
  .app-tabbar {
    display: none;
  }

  .app-content {
    padding: 30px 32px 48px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/AppLayout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,2DAA2D;EAC3D,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".app-shell {\n  display: flex;\n  min-height: 100vh;\n  background: var(--bg);\n}\n\n.app-side {\n  position: sticky;\n  top: 0;\n  display: none;\n  flex-direction: column;\n  width: 254px;\n  height: 100vh;\n  padding: 22px 16px;\n  background: var(--surface);\n  border-right: 1px solid var(--border);\n}\n\n.app-side-brand {\n  display: block;\n  padding: 0 8px 22px;\n}\n\n.app-side-brand img {\n  height: 44px;\n  width: auto;\n}\n\n.app-side-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.app-side-link {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 11px 12px;\n  border-radius: var(--radius-sm);\n  font-family: var(--font-display);\n  font-size: 0.92rem;\n  font-weight: 600;\n  color: var(--muted);\n  text-decoration: none;\n  transition: background 0.2s, color 0.2s;\n}\n\n.app-side-link:hover {\n  background: var(--brand-50);\n  color: var(--brand);\n}\n\n.app-side-link.active {\n  background: var(--brand);\n  color: #fff;\n  box-shadow: var(--shadow-brand);\n}\n\n.app-side-foot {\n  margin-top: auto;\n  padding-top: 18px;\n  border-top: 1px solid var(--border);\n}\n\n.app-user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 4px 14px;\n}\n\n.app-user-avatar,\n.app-user-initials {\n  flex-shrink: 0;\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.app-user-initials {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--grad-brand);\n  color: #fff;\n  font-family: var(--font-display);\n  font-size: 0.82rem;\n  font-weight: 700;\n}\n\n.app-user-info {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  line-height: 1.3;\n}\n\n.app-user-info strong {\n  font-size: 0.88rem;\n  color: var(--text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.app-user-info span {\n  font-size: 0.76rem;\n  color: var(--muted2);\n}\n\n.app-signout {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 10px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: #fff;\n  color: var(--muted);\n  font-family: var(--font-display);\n  font-size: 0.86rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 0.2s, color 0.2s;\n}\n\n.app-signout:hover:not(:disabled) {\n  border-color: var(--danger-100);\n  color: var(--danger);\n}\n\n.app-signout:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.app-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.app-topbar {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 18px;\n  background: rgba(255, 255, 255, 0.94);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid var(--border);\n}\n\n.app-topbar-brand img {\n  height: 38px;\n  width: auto;\n  display: block;\n}\n\n.app-topbar-user {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  overflow: hidden;\n  background: var(--grad-brand);\n  color: #fff;\n  font-family: var(--font-display);\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.app-topbar-user img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.app-content {\n  flex: 1;\n  padding: 20px 18px calc(76px + env(safe-area-inset-bottom));\n  max-width: 1080px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.app-tabbar {\n  position: fixed;\n  z-index: 200;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  background: rgba(255, 255, 255, 0.96);\n  backdrop-filter: blur(12px);\n  border-top: 1px solid var(--border);\n  padding-bottom: env(safe-area-inset-bottom);\n}\n\n.app-tab {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n  padding: 9px 2px 8px;\n  color: var(--muted2);\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.app-tab span {\n  font-family: var(--font-display);\n  font-size: 0.66rem;\n  font-weight: 600;\n  letter-spacing: -0.1px;\n}\n\n.app-tab.active {\n  color: var(--brand);\n}\n\n@media (min-width: 900px) {\n  .app-side {\n    display: flex;\n  }\n\n  .app-topbar,\n  .app-tabbar {\n    display: none;\n  }\n\n  .app-content {\n    padding: 30px 32px 48px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
